import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { pageHead } from "@/lib/route-head";
const First500 = lazy(() => import("@/pages/First500"));

export const Route = createFileRoute("/first-500/")({
  component: First500,
  head: () =>
    pageHead({
      path: "/first-500",
      title: "Join Your City’s First 500 — Amorette",
      description:
        "Claim a free, numbered founding place in your city’s First 500 and be first invited when Amorette opens near you. A founding place is not a dinner reservation.",
    }),
});
